import { action } from 'src/store/actions';

/* Customer Messages (customer-visible notes, F-KD-02) */
export const FETCH_CUSTOMER_MESSAGES = 'FETCH_CUSTOMER_MESSAGES';
export const REQUEST_CUSTOMER_MESSAGES = 'REQUEST_CUSTOMER_MESSAGES';
export const SUCCESS_CUSTOMER_MESSAGES = 'SUCCESS_CUSTOMER_MESSAGES';
export const FAILURE_CUSTOMER_MESSAGES = 'FAILURE_CUSTOMER_MESSAGES';

export const fetchCustomerMessages = () => action(FETCH_CUSTOMER_MESSAGES);
export const requestCustomerMessages = () => action(REQUEST_CUSTOMER_MESSAGES);
export const requestCustomerMessagesSuccess = (response: any) => action(SUCCESS_CUSTOMER_MESSAGES, { response });
export const requestCustomerMessagesFailure = (error: any) => action(FAILURE_CUSTOMER_MESSAGES, { error });

export const SUCCESS_CUSTOMER_MESSAGE_READ = 'SUCCESS_CUSTOMER_MESSAGE_READ';

export const markCustomerMessageReadSuccess = (messageId: string) =>
    action(SUCCESS_CUSTOMER_MESSAGE_READ, { messageId });
